import React, { useState } from 'react';
import axios from 'axios';
import { Form, Button, Alert } from 'react-bootstrap';

function GetPDF({lang}){
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState(null);

  let locale = lang.getpdf;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage({ type: 'success', text: "Thank you! The guide is sent on your mail!" });
  
    try {
      console.log('Sending request with data:', { email, language: lang.lang });
      const response = await axios.get('/backend/get-pdf.php', {
        params: {
          email: email,
          language: lang.lang
        }
      });
      console.log('Response received:', response.data);
    } catch (error) {
      console.error('Error in API call:', error);
      if (error.response) {
        console.error('Error data:', error.response.data);
        setMessage({ type: 'danger', text: error.response.data.message || locale.msgfail });
      } else {
        setMessage({ type: 'danger', text: locale.msgfail });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="get-pdf-container">
        <div className="row">
            <div className="col-12 col-md-8 full-w-900">
                <h2>Leave your email and get a FREE guide</h2>
                <h2 className='secondary-header'>on how to become a Onlyfans model by yourself!</h2>
                <div className="form-wrapper">
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formEmail">
                        <Form.Control
                            type="email"
                            placeholder="Enter mail"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        </Form.Group>
                        <Button variant="primary" type="submit" disabled={isLoading}>
                        {isLoading ? 'Sending...' : "Send"}
                        </Button>
                    </Form>
                </div>
                {message && message.type === 'success' && (
                  <div className="success-message mt-3">
                    {message.text}
                  </div>
                )}
                {message && message.type === 'danger' && (
                  <Alert variant={message.type} className="mt-3">
                    {message.text}
                  </Alert>
                )}
            </div>
            <div className="col-0 col-md-4 hide-on-900">
                <div className="bg-image"></div>
            </div>
      </div>
      </div>
    </div>
  );
};

export default GetPDF;